import { computed, Ref, unref } from "@vue/composition-api"

export default function useStore(nombre: string | Ref<string>) {

    const getJson = () => {
        const item = localStorage.getItem(unref(nombre))

        try {
            return JSON.parse(item)
        }
        catch {
            return {}
        }
    }

    const valor = computed({
        get: getJson,
        set(json) {
            const item = JSON.stringify(json)
            localStorage.setItem(unref(nombre), item)
        }
    })

    return { valor }
}